export const imageUrl = (path) => 'https://cpanel.awronore.krd' + path;
